export default __webpack_public_path__ + "static/TlgGray-2b4877f3a0763c4f5d16328d12614ea0.png";